const SIZE_40GB = 40 * 1024 * 1024 * 1024;

/**
 * Find files > 40gb files
 * @param {Object[]} filesToAdd
 * @returns {Object[]} duplicated file names
 */
export default function findLargeFiles(filesToAdd) {
  const result = [];

  filesToAdd.forEach((item) => {
    if (item.file.size > SIZE_40GB) {
      result.push({ size: item.file.size, name: item.path + item.name });
    }
  });

  return result;
}
